<template>
    <div>
        <div class="d-flex pa-2">
            <div class="d-flex align-center">
                <OBtnToolTipHeaderComp
                    v-if="!mobile"
                    :icono="mini ? 'mdi-arrow-right-bold-box' : 'mdi-arrow-left-bold-box'"
                    smsToolTip="Ocultar Menú"
                    @click="$emit('clickmini')"
                />
                <h1 :class="mobile ? 'app-title' : 'app-title ml-2'">
                    {{`TIPOS PRODUCTOS (${total})`}}
                </h1>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
                <OBtnToolTipHeaderComp
                    icono="mdi-plus"
                    class="mr-1"
                    smsToolTip="Registrar laboratorio"
                    @click="eOpenForm()"
                />
                <OBtnToolTipHeaderComp
                    icono="mdi-database"
                    smsToolTip="Volver a laboratorios"
                    @click="eBackTableList()"
                />
            </div>
        </div>
        <div class="client__line-header" id="position-scroll"></div>
        <v-tabs-items
            style="background:transparent !important"
            v-model="tab"
            :touchless="true"
        >
            <v-tab-item>
                <OLoaderDataComp
                    class="mt-2"
                    v-if="dialogLoaderData"
                    smsLoaderData="Obteniendo Información"
                />
                <MNoDataComp
                    smsNotData="SIN DATOS"
                    class="ma-1"
                    v-if="typesProductsList.length==0 && !dialogLoaderData"
                />
                <div class="d-flex justify-center flex-wrap">
                    <SCardTypeProductComp
                        class="ma-2"
                        v-for="typeProduct in typesProductsList"
                        :key="typeProduct.id"
                        :mobile="mobile"
                        :typeProduct="typeProduct"
                        @clickedit="eOpenFormEdit(typeProduct)"
                        @clickdelete="eConfirmDelete(typeProduct)"
                    />
                </div>
            </v-tab-item>
            <v-tab-item>
                <div class="d-flex justify-center mt-3 pl-2 pr-2 pb-2">
                    <SFormTypeProductComp
                        ref="formtypeproductcomp"
                        :dataTypeProduct="dataTypeProduct"
                        :mobile="mobile"
                        :indexTypeProduct="indexTypeProduct"
                        @saveform="eConfirmForm"
                    />
                </div>
            </v-tab-item>
        </v-tabs-items>
        <OSmsConfirmationComp
            :value="dialogConfirm"
            :smsConfirm="smsConfirm"
            :mobile="mobile"
            @clickno="eCloseDialogConfirm()"
            @clickyes="ePerformDatabaseAction()"
        />
        <OSmsErrorComp
            :smsError="smsError"
            :value="dialogError"
            :actionError="actionError"
            :mobile="mobile"
            @click="eCloseError()"
        />
        <OSmsActionComp
            :value="frameCorrect"
            :colorMessage="colorMessage"
            :smsAction="smsAction"
            :timeSucess="timeSucess"
            @click="mDataGeneralFrameTimeReset()"
        />
        <OOperationLoaderComp
            smsLoaderOperation="Realizando Operación"
            :value="dialogLoaderOperation"
        />
    </div>
</template>
<script>
import { MNoDataComp } from "../../components/molecules";
import {
    OBtnToolTipHeaderComp,
    OLoaderDataComp,
    OSmsConfirmationComp,
    OSmsErrorComp,
    OSmsActionComp,
    OOperationLoaderComp
} from "../../components/organisms";
import {
    SCardTypeProductComp,
    SFormTypeProductComp
} from "../../components/species";
import {
    animationScrollMixin,
    responseServerMixin,
    dataGeneralCompsMixin,
    userMixin,
    datesMixin
} from "../../mixins";
import { TypeProduct } from "../../models";
export default {
    props: {
        mini: Boolean
    },
    mixins: [
        animationScrollMixin,
        responseServerMixin,
        dataGeneralCompsMixin,
        userMixin,
        datesMixin
    ],
    components: {
        OBtnToolTipHeaderComp,
        MNoDataComp,
        OLoaderDataComp,
        SCardTypeProductComp,
        OSmsConfirmationComp,
        OSmsErrorComp,
        OSmsActionComp,
        OOperationLoaderComp,
        SFormTypeProductComp
    },
    data: () => ({
        tab: 0,
        dataTypeProduct: new TypeProduct,
        indexTypeProduct: -1,
        typesProductsList: [],
        idTypeProduct: 0
    }),
    methods: {
        eCloseError() {
            if (this.noAccess.withoutAutorization)
                this.mDataGeneralActionWithOutAutorization();
            else {
                if (this.idTypeProduct > 0) {
                    this.idTypeProduct = 0;
                    this.indexTypeProduct = -1;
                }
                this.dialogError = false;
            }
        },
        handleKeyUpTypeProduct(event) {
            if (!this.mobile) {
                const actionKeyBoard = this.mDataGeneralActionKeyboard(event.keyCode);
                if (actionKeyBoard === 0) this.eCloseDialogConfirm();
                if (actionKeyBoard === 1) this.ePerformDatabaseAction();
                if (actionKeyBoard === 2) this.eCloseError();
            }
        },
        processErrorServer(error) {
            this.dialogLoaderOperation = false;
            this.noAccess = this.mResponseServeAutorization(error);
            this.smsError = this.mResposeServerSmsError(error);
            this.actionError = this.mResponseServeAction(error);
            this.dialogError = true;
        },
        async getTypesProducts() {
            try {
                const response = await TypeProduct.getTypesProducts();
                this.typesProductsList = response;
                this.dialogLoaderData = false;
            } catch(error) {
                this.processErrorServer(error);
            }
        },
        eConfirmForm(isValidForm) {
            const smsConfirm = this.indexTypeProduct === -1
                ? [`¿Está seguro(a) de registrar: ${this.dataTypeProduct.type_product}?`]
                : [`¿Está seguro(a) de editar: ${this.dataTypeProduct.type_product}?`];
            this.mDataGeneralConfirmForm(isValidForm, smsConfirm);
        },
        eCloseDialogConfirm() {
            if (this.idTypeProduct > 0) {
                this.idTypeProduct = 0;
                this.indexTypeProduct = -1;
            }
            this.dialogConfirm = false;
        },
        eBackTableList() {
            if (this.tab !== 0) {
                this.indexTypeProduct = -1;
                this.dataTypeProduct = new TypeProduct();
                this.$refs.formtypeproductcomp.resetForm();
                this.dialogLoaderOperation = false;
                this.tab = 0;
            }
        },
        async addTypeProduct() {
            try {
                const response = await TypeProduct.addTypeProduct(this.dataTypeProduct);
                this.typesProductsList.unshift(response);
                this.total += 1;
                this.eBackTableList();
                this.mDataGeneralShowSmsAction(["Operación Exitosa", "Se registró el tipo producto"], "success");
            } catch (error) {
                this.processErrorServer(error);
            }
        },
        async editTypeProduct() {
            try {
                const response = await TypeProduct.editTypeProduct(this.dataTypeProduct);
                Object.assign(this.typesProductsList[this.indexTypeProduct], response);
                this.eBackTableList();
                this.mDataGeneralShowSmsAction(["Operación Exitosa", "Se editó el tipo producto"], "success");
            } catch (error) {
                this.processErrorServer(error);
            }
        },
        async deleteTypeProduct() {
            try {
                await TypeProduct.deleteTypeProduct({id: this.idTypeProduct});
                this.typesProductsList.splice(this.indexTypeProduct, 1);
                this.total -= 1;
                this.idTypeProduct = 0;
                this.indexTypeProduct = -1;
                this.dialogLoaderOperation = false;
                this.mDataGeneralShowSmsAction(["Operación Exitosa", "Se eliminó el tipo producto"], "success");
            } catch (error) {
                this.processErrorServer(error);
            }
        },
        ePerformDatabaseAction() {
            this.dialogConfirm = false;
            this.dialogLoaderOperation = true;
            if (this.idTypeProduct > 0) this.deleteTypeProduct();
            else {
                if (this.indexTypeProduct === -1)
                    this.addTypeProduct();
                else this.editTypeProduct();
            }
        },
        eOpenFormEdit(typeProduct) {
            this.indexTypeProduct = this.typesProductsList.indexOf(typeProduct);
            this.dataTypeProduct = Object.assign({}, typeProduct);
            const time = this.mAnimationScrollTime();
            this.$vuetify.goTo(0, this.mAnimationScrollOptions(time));
            setTimeout(() => {
                this.tab = 1;
                setTimeout(() => {
                    this.$refs.formtypeproductcomp.activateFocus();
                }, 150);
            }, time);
        },
        eConfirmDelete(typeProduct) {
            this.idTypeProduct = typeProduct.id;
            this.indexTypeProduct = this.typesProductsList.indexOf(typeProduct);
            this.smsConfirm = [`¿Está seguro(a) de eliminar: ${typeProduct.type_product}?`];
            const time = this.mAnimationScrollTime();
            this.$vuetify.goTo(0, this.mAnimationScrollOptions(time));
            setTimeout(() => {
                this.dialogConfirm = true;
            }, time);
        },
        eOpenForm() {
            this.tab = 1;
            setTimeout(() => {
                this.$refs.formtypeproductcomp.activateFocus();
            }, 150);
        }
    },
    mounted() {
        if (window.innerWidth <= 600) this.mobile = true;
        if (this.mUserSaveHeader(this.mDateSystem(false))) {
            if (this.mUserCategorie() === "0") {
                window.addEventListener('keyup', this.handleKeyUpTypeProduct);
                this.getTypesProducts();
            } else this.$router.replace('/home');
        } else this.$router.replace('/login');
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyUpTypeProduct);
    }
}
</script>